if (!customElements.get('dvtb-pi-gallery')) {
  class DvtbPiGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.dvtb-pi-main-track');
      this.slides = Array.from(this.querySelectorAll('.dvtb-pi-slide'));
      this.thumbs = Array.from(this.querySelectorAll('.dvtb-pi-thumb'));
      this.prevBtn = this.querySelector('.dvtb-pi-arrow--prev');
      this.nextBtn = this.querySelector('.dvtb-pi-arrow--next');
      this.index = 0;

      this.prevBtn?.addEventListener('click', () => this.go(this.index - 1));
      this.nextBtn?.addEventListener('click', () => this.go(this.index + 1));
      this.thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => this.go(i)));

      // Slides 2+ are rendered without src (see the section) so they don't
      // compete with the first image. Once the page has loaded only the next
      // slide is fetched; the rest (~350 KB) only when the shopper reaches for
      // the gallery — a touch, the mouse over it or keyboard focus, all of
      // which come before the swipe/tap that shows another slide. Most
      // visitors never open the gallery and no longer pay for it.
      // Thumbnails wait for the main photo (or 4 s at most): on a slow
      // connection they were competing with it for the same bandwidth.
      const showThumbs = () => {
        if (this.thumbsShown) return;
        this.thumbsShown = true;
        this.querySelectorAll('.dvtb-pi-thumb img[data-src]').forEach((img) => {
          if (img.dataset.srcset) img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          img.removeAttribute('data-src');
          img.removeAttribute('data-srcset');
        });
      };
      const hero = this.slides[0] && this.slides[0].querySelector('img');
      if (!hero || (hero.complete && hero.naturalWidth > 0)) showThumbs();
      else {
        hero.addEventListener('load', showThumbs, { once: true });
        hero.addEventListener('error', showThumbs, { once: true });
        setTimeout(showThumbs, 4000);
      }

      const hydrate = () => this.hydrateSlides();
      if (document.readyState === 'complete') this.scheduleHydrate();
      else window.addEventListener('load', () => this.scheduleHydrate(), { once: true });
      ['pointerdown', 'touchstart', 'pointerenter', 'focusin'].forEach((type) => {
        this.addEventListener(type, hydrate, { once: true, passive: true });
      });

      this.addEventListener('touchstart', (event) => { this.touchStartX = event.touches[0].clientX; }, { passive: true });
      this.addEventListener('touchend', (event) => {
        if (this.touchStartX == null) return;
        const delta = event.changedTouches[0].clientX - this.touchStartX;
        if (Math.abs(delta) > 40) this.go(this.index + (delta < 0 ? 1 : -1));
        this.touchStartX = null;
      });

      this.render();
    }

    scheduleHydrate() {
      const next = () => this.hydrateSlide(this.slides[1]);
      if ('requestIdleCallback' in window) requestIdleCallback(next, { timeout: 2000 });
      else setTimeout(next, 200);
    }

    hydrateSlide(slide) {
      const img = slide && slide.querySelector('img[data-src]');
      if (!img) return;
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    }

    hydrateSlides() {
      if (this.hydrated) return;
      this.hydrated = true;
      this.slides.forEach((slide) => this.hydrateSlide(slide));
    }

    go(index) {
      const total = this.slides.length;
      // The slide being shown is requested first, then the others.
      this.hydrateSlide(this.slides[(index + total) % total]);
      this.hydrateSlides();
      this.index = (index + total) % total;
      this.render();
      const video = this.slides[this.index].querySelector('video');
      if (video) video.play().catch(() => {});
    }

    render() {
      if (this.track) this.track.style.transform = `translateX(-${this.index * 100}%)`;
      this.thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === this.index));
      this.slides.forEach((slide, i) => {
        const video = slide.querySelector('video');
        if (video && i !== this.index) video.pause();
      });
    }
  }

  customElements.define('dvtb-pi-gallery', DvtbPiGallery);
}
